import React from "react";
import { Brand } from "../shared/Brand";

export function Footer() {
  return (
    <>
      <div className="goldbar" />
      <footer className="evfooter">
        <div className="wrap">
          <div className="fbrand"><Brand /></div>
          <div className="c">
            <b>Energy Vault Group</b> · Barnhill, Inchinnan Road, Houston PA4 9LU<br />
            0141 345 1256 · michael@energyvaultgroup.co.uk · www.energyvaultgroup.co.uk<br />
            <b>Measure with Confidence. Act with Impact.</b>
          </div>
        </div>
      </footer>
    </>
  );
}
